import React from 'react'
import PropTypes from 'prop-types'

export default function StepIcon(props) {
  let iconProps = {
    ...props,
    active: props.active.toString(),
    hovered: props.hovered.toString()
  }
  let iconStyles = {
    fill: '#404040'
  }
  if (props.hovered) {
    iconStyles.fill = '#fafafa'
  } else if (props.active) {
    iconStyles.fill = '#f37735'
  }
  iconProps = {
    ...iconProps,
    ...iconStyles
  }
  if (props.viewbox) {
    iconProps.viewbox = props.viewbox
  }
  return (
    <svg width={iconProps.width} height={iconProps.height} fill='none' xmlns='http://www.w3.org/2000/svg' {...iconProps}>
      <rect x='0.856934' width={iconProps.width} height={iconProps.height} rx='2' fill={iconProps.fill} />
    </svg>
  )
}

StepIcon.propTypes = {
  active: PropTypes.bool,
  height: PropTypes.number,
  hovered: PropTypes.bool,
  viewbox: PropTypes.string,
  width: PropTypes.number
}

StepIcon.defaultProps = {
  active: false,
  height: 33,
  hovered: false,
  width: 30
}
